module.exports = __webpack_public_path__ + "static/img18-1566684c843c0ff7a8c6b79de0fd4496.jpg";